import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { useRef, useEffect } from "react";
import Scroll from "./scroll/scroll";
gsap.registerPlugin(ScrollSmoother);

function App() {
  const pin = useRef<HTMLDivElement>(null);
  const smoother = useRef<ScrollSmoother>();

  useEffect(() => {
    ScrollTrigger.clearScrollMemory();
    window.history.scrollRestoration = "manual"
  },[]);

  return (
    <div>
      <Scroll />
    </div>
  );
}

export default App;
